// Version : 1.0.0
// Author : AGALYA
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** EXTRA INFORMATION SERVICE START *********************** */
export const extraMemberInformationAdd = (verifyData: any) => {
	const data = {
		CreateExtraInformationToken: verifyData,
	};
	const url = `${API_URL}addExtraInformation`;
	return makeApiCall(url, data);
};
/** ***************** EXTRA INFORMATION SERVICE END *********************** */
